import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Single labelled `<dt>`/`<dd>` pair for a result card `<dl>`; renders "—" for
 * empty values (`null`, `undefined`, or `''`). Extracted from the identical
 * `Field` helper duplicated across the identity and payment test-tool routes.
 */
export function DefinitionField({ label, value }) {
    const text = value === null || value === undefined || value === '' ? '—' : String(value);
    return (_jsxs("div", { className: "flex flex-col gap-0.5", children: [_jsx("dt", { className: "text-xs uppercase tracking-wide text-[var(--color-text-muted)]", children: label }), _jsx("dd", { className: "text-sm text-[var(--color-text-primary)]", children: text })] }));
}
//# sourceMappingURL=definition-field.js.map